import React from 'react';
import './ExportingOverlay.scss';

interface ExportingOverlayProps {
  message?: string;
}

export const ExportingOverlay: React.FC<ExportingOverlayProps> = ({
  message,
}) => (
  <div className="exporting-indicator">
    <div className="exporting-indicator__content">
      <span className="exporting-indicator__spinner" />
      {message || 'Loading...'}
    </div>
  </div>
);
